module.exports = __webpack_public_path__ + "static/finger-snap-31a6a960b0b990ce76efbe29daf41e0b.wav";